import { Component } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MasterMakeService} from "../../share/services/master-make/master-make.service";

@Component({
    selector: 'app-tyre-brand',
    templateUrl: './tyre-brand.component.html',
    styleUrls: ['./tyre-brand.component.scss'],
    standalone: false
})
export class TyreBrandComponent {
  addTyreBrandForm: FormGroup;
  responseMsg: string;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly masterMakeService: MasterMakeService
  ){
    this.addTyreBrandForm = this.formBuilder.group({
      name: ['', [ Validators.required]],
    });
  }
  saveTyreBrand(){
    this.masterMakeService.saveTyreMake(this.addTyreBrandForm.value).subscribe((res:any) => {
      this.responseMsg = res.message
    })
  }
}
